








































































































































import mixins from 'vue-typed-mixins';
import { Question } from '@/utils/SurveyUtils';
import { ReportNode, QuestionData } from '@/utils/ReportUtils';
import { clean } from '@/utils/CommonUtils';
import { MultipleChoiceOptions } from '@/components/survey/questions/options';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => ReportNode<Question, QuestionData>,
    },
  },
  computed: {
    answer(): any {
      return this.value.data?.participation?.answer || {};
    },

    readonly(): boolean {
      return !this.value.data.editable || false;
    },

    choices(): any {
      let choices: MultipleChoiceOptions['choices'] = Array.from(
        this.value.item?.options?.choices
      );

      choices?.sort(
        (
          a: MultipleChoiceOptions['choices'][0],
          b: MultipleChoiceOptions['choices'][0]
        ) => {
          if (this.value.item.options.sort === 'alphabetical') {
            if (
              (clean(this.$translate(a.shorttext)) as string) <
              (clean(this.$translate(b.shorttext)) as string)
            ) {
              return -1;
            } else if (
              (clean(this.$translate(a.shorttext)) as string) >
              (clean(this.$translate(b.shorttext)) as string)
            ) {
              return 1;
            }
          }
          return 0;
        }
      );

      if (this.value.item.options.other) {
        const index = choices.findIndex((choice) => choice.key === 'other');
        if (index < 0) {
          choices.push({
            shorttext: this.$languageobj(
              'model.question.options.multiple_choice.other.checkbox'
            ),
            key: 'other',
          });
        }
      }

      return choices?.map((choice: MultipleChoiceOptions['choices'][0]) => ({
        text: this.$translate(choice.shorttext),
        description: this.$translate(choice.longtext),
        value: choice.key,
      }));
    },
    showOther(): any {
      if (Array.isArray(this.answer.value)) {
        return this.answer.value.some((value: string) => value === 'other');
      } else {
        return this.answer.value === 'other';
      }
    },
  },
  watch: {
    showOther() {
      if (!this.showOther) {
        this.answer.other = '';
      }
    },
  },
  methods: {
    handleChange() {
      this.$emit('dirty');
      if (this.value.data.participation) {
        let completeness = 0;
        if (this.answer.value || this.answer.notes?.length > 0) {
          completeness++;
        }
        this.value.data.participation.completeness = completeness / 1;
      }
    },
  },
});
